import { Link } from 'react-router-dom';
import { SEO } from '../components/SEO';
import { FaStar, FaCheckCircle, FaChevronRight } from 'react-icons/fa';

const offers = [
  {
    id: 'allbritishcasino',
    name: 'All British Casino',
    image: '/images/offers/allbritishcasino.webp',
    bonus: '100% up to £100',
    rating: 4.8,
    features: ['Fast Payouts', 'UK Licensed', 'Live Casino'],
    description: 'Premium gaming experience with excellent customer service and fast withdrawals.',
    url: 'https://www.allbritishcasino.com/'
  },
  {
    id: 'partycasino',
    name: 'PartyCasino',
    image: '/images/offers/partycasino.webp',
    bonus: '200% up to £200',
    rating: 4.7,
    features: ['VIP Program', 'Mobile App', 'Tournaments'],
    description: 'Exciting tournaments, comprehensive VIP program, and massive game library.',
    url: 'https://www.partycasino.com/'
  },
  {
    id: 'plazaroyal',
    name: 'Plaza Royal',
    image: '/images/offers/plazaroyal.webp',
    bonus: '150% up to £150',
    rating: 4.6,
    features: ['Crypto Accepted', '24/7 Support', 'Exclusive Games'],
    description: 'Modern technology meets classic elegance with cryptocurrency support.',
    url: 'https://www.plazaroyal.com'
  }
];

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'CollectionPage',
  name: 'UK Casino Offers',
  description: 'Browse all available UK casino offers and bonuses'
};

export const Offers = () => {
  return (
    <>
      <SEO
        title="All UK Casino Offers & Bonuses 2025"
        description="Browse all available UK casino offers, bonuses, and promotions. Compare welcome bonuses, free spins, and exclusive deals from top-rated casinos."
        canonical="/offers"
        jsonLd={jsonLd}
      />

      <div className="min-h-screen pt-20 pb-20">
        <section className="py-12 bg-gradient-to-br from-dark-900 via-dark-800 to-dark-900">
          <div className="container mx-auto px-4">
            <div className="text-center mb-12">
              <h1 className="text-4xl md:text-6xl font-bold mb-4 bg-gradient-to-r from-primary-400 to-accent-400 bg-clip-text text-transparent">
                All Casino Offers
              </h1>
              <p className="text-xl text-gray-400 max-w-3xl mx-auto">
                Explore the best UK casino bonuses and promotions. Compare offers and find your perfect match.
              </p>
            </div>

            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              {offers.map((offer) => (
                <div
                  key={offer.id}
                  className="bg-dark-800 border border-gray-700 rounded-2xl overflow-hidden hover:border-primary-500 transition-all duration-300 hover:shadow-2xl hover:shadow-primary-500/20 group"
                >
                  <div className="relative h-48 overflow-hidden">
                    <img
                      src={offer.image}
                      alt={offer.name}
                      className="w-full h-full object-contain group-hover:scale-110 transition-transform duration-500"
                      loading="lazy"
                    />
                    <div className="absolute top-4 right-4 bg-primary-500 text-white px-3 py-1 rounded-full text-sm font-semibold">
                      {offer.bonus}
                    </div>
                  </div>
                  <div className="p-6">
                    <div className="flex items-center justify-between mb-4">
                      <h3 className="text-2xl font-bold text-white">{offer.name}</h3>
                      <div className="flex items-center space-x-1">
                        <FaStar className="text-yellow-400" />
                        <span className="text-white font-semibold">{offer.rating}</span>
                      </div>
                    </div>
                    <p className="text-gray-400 mb-4 text-sm">{offer.description}</p>
                    <ul className="space-y-2 mb-6">
                      {offer.features.map((feature, i) => (
                        <li key={i} className="flex items-center text-gray-300 text-sm">
                          <FaCheckCircle className="text-primary-400 mr-2 flex-shrink-0" />
                          {feature}
                        </li>
                      ))}
                    </ul>
                    <div className="flex gap-3">
                      <a
                        href={offer.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-gradient-to-r from-primary-500 to-accent-500 text-white text-center font-semibold py-3 rounded-lg hover:from-primary-600 hover:to-accent-600 transition-all duration-200"
                      >
                        Claim Bonus
                      </a>
                      <Link
                        to={`/offers/${offer.id}`}
                        className="flex-1 bg-dark-800 border border-gray-700 text-white text-center font-semibold py-3 rounded-lg hover:border-primary-500 transition-all duration-200 flex items-center justify-center"
                      >
                        Review
                        <FaChevronRight className="ml-2" />
                      </Link>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

